exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-leadgen-v2-Common-Phone__phone-number--1Kr3l{color:#18C7AF;font-size:18px;line-height:34px;text-decoration:none}\n", ""]);

// Exports
exports.locals = {
	"phone-number": "src-components-leadgen-v2-Common-Phone__phone-number--1Kr3l",
	"phoneNumber": "src-components-leadgen-v2-Common-Phone__phone-number--1Kr3l"
};